
      <!--  MULTI CONTROL  -->

      <div [formGroup]="form">

          <div class="multi-control-container" [formGroup]="form.controls[uiFormControl.name]" [ngClass]="uiFormControl.orientation">

              <!-- CONTROL LOOP  -->

              <div *ngFor="let item of items" class="child-control-container">

                  <!--  CONTROL SELECTOR  -->

                  <ui-control-selector
                      [form]="form.controls[uiFormControl.name]"
                      [uiFormControl]="item"
                      [isInvalid]="isInvalid(form.controls[uiFormControl.name], item)"
                      [invalidReasons]="getInvalidReasons(form.controls[uiFormControl.name], item)"
                      (onEvent)="onChildEvent($event)">
                  </ui-control-selector>

                  <!--  END CONTROL LOOP  -->

              </div>

              <!--  END CONTROL LOOP  -->

          </div>

      </div>

      <!--  END MULTI CONTROL  -->
    